import React from 'react'
import moment from 'moment'
import api from '../../../apiClient/v1'
let PropTypes = React.PropTypes
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'
//Componentes
import { TableDetails } from './TableDetails.jsx'
import { InformativoRendicion } from './InformativoRendicion.jsx'

//CSS
import css from '../../asignacion-fondos/Fondos.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)
moment.locale('es')

export class DetailsRendicion extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            rendicion : this.props.rendicion,
            gastos: this.props.gastos,
            cambio: false
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
    }
    cerrarRendicion(){
        api.fondos().cerrarFondo(this.state.rendicion.idRendicion)
            .then(rendicion=>{
                this.refs.notificator.success("Rendicion", "Rendición cerrada correctamente", 4*1000);
            })
            .catch(this.ajaxErrorHandler('Error al intentar cerrar la rendición'))
    }
    getChildContext(){
        return {
            aprobarGasto: (idGasto)=>{
                api.gastos().aprobarGasto(idGasto)
                    .then(gasto=>{
                        this.refs.notificator.success("Gasto", "Gasto aprobado", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al aprobar gasto'))
            },
            rechazarGasto: (idGasto)=>{
                let request = api.gastos().rechazarGasto(idGasto)
                request
                    .then(gasto=>{
                        this.refs.notificator.success("Gasto", "Gasto rechazado", 4*1000);
                    })
                    .catch(this.ajaxErrorHandler('Error al rechazar gasto'))
                return request
            }
        }
    }
    render() {
        return (
            <div className="container-fluid">
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="page-header row">
                            <div className={cx("col-md-12", 'titleFinance')}>
                                <div className={cx("col-md-9", 'divTitle')}>
                                    <h3><span className="glyphicon glyphicon-list"></span> Detalle de rendición</h3>
                                </div>
                                <div className={cx("col-md-2", 'divNavBar')}>
                                    <button className="btn btn-md btn-warning"
                                        onClick={this.cerrarRendicion.bind(this)}
                                    >
                                        <span className={'glyphicon glyphicon-bookmark'}></span> Cerrar Rendición
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                        <InformativoRendicion
                            fondo={this.state.rendicion}
                        />
                        {this.state.gastos.length === 0 ?
                            null
                            :
                            <div className={cx("col-md-12", 'divFinance')}>
                                <div className="row">
                                    <div className="col-md-10">
                                        <h5 className={css.textInformation}>Gastos asociados a la rendición*</h5>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <a className="btn btn-md btn-info pull-right"
                                           href={`/#`}>
                                            <span className={'glyphicon glyphicon-ok'}></span> Aprobar Todos
                                        </a>
                                    </div>
                                </div>
                                <div className="row">
                                    <TableDetails
                                        gastos={this.state.gastos}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
DetailsRendicion.propTypes = {
    rendicion: PropTypes.object.isRequired,
    gastos: PropTypes.arrayOf(PropTypes.object).isRequired,
}
DetailsRendicion.childContextTypes = {
    aprobarGasto: PropTypes.func,
    rechazarGasto: PropTypes.func
}



// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/detalle-rendicion/DetailsRendicion.jsx